import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="utility-menu-divider-wrapper">
  <div class="utility-menu-divider">
    <wa-divider class="divider"></wa-divider>
  </div>
</div>
`

class NavHeaderUtilityMenuDivider extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Divider])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }
}

if (!customElements.get('ts-navheader-utility-menu-divider')) {
  customElements.define('ts-navheader-utility-menu-divider', NavHeaderUtilityMenuDivider)
}

export { NavHeaderUtilityMenuDivider }
